import { DataViewState, useSearchState } from '@vtex/admin-ui'
import { useEffect, useMemo } from 'react'
import { Item } from 'typings'
import { searchItems } from '../../../../utils'

export const DEBOUNCE_TIMEOUT = 500

type Props = {
  items: Item[]
  dataState: DataViewState
}

export function useSearch(props: Props) {
  const { items, dataState } = props

  const { debouncedValue, ...rest } = useSearchState({
    timeout: DEBOUNCE_TIMEOUT,
  })

  const filteredItems = useMemo(
    () => searchItems(items, debouncedValue),
    [debouncedValue, items]
  )

  useEffect(() => {
    if (filteredItems.length && dataState.status !== 'ready') {
      dataState.setStatus({ type: 'ready' })
    }

    if (!filteredItems.length && dataState.status !== 'not-found') {
      dataState.setStatus({ type: 'not-found' })
    }
  }, [dataState, filteredItems.length])

  return { filteredItems, ...rest }
}
